export const TEST_ID = 'resultSection';
